import { PropertyBookletBuildingService } from '@/components/booklet/property-booklet-building-card/property-booklet-building.service';
import { Pipe, PipeTransform } from '@angular/core';
import { PropertyBookletBuildingStage } from '@eemo/api-client';

@Pipe({
    name: 'bookletBuildingStageTranslate',
    standalone: true
})
export class BookletBuildingStageTranslatePipe implements PipeTransform {

  transform(stage: PropertyBookletBuildingStage): unknown {
    return PropertyBookletBuildingService.getBookletBuildingStageTranslate(stage);
  }

}
